<template>
	<inertia-head title="SAM Table Management" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">SAM Table Management</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Stocks List</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="text-end mb-4">
			<button @click="viewSamTableModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add Stock
			</button>
		</div>
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title fs-xs">
					<label class="fw-bold">Legends:</label>
					<div>
						<!-- <div>1 - BOSS (Bo's Strategic Stock)</div> -->
						<div>2 - Stocks with Bigger Cash Dividends</div>
						<div>3 - Mature Stocks</div>
						<div>4 - Young Growth Stocks</div>
						<div>5 - REIT's</div>
						<div>6 - Equity Funds</div>
						<div>7 - Bonds</div>
					</div>
				</div>
				<div class="block-options">
					<div class="input-group">
						<span class="input-group-text">Show</span>
						<select v-model="filter" name="filter" class="form-select">
							<option value="null">Only SAM</option>
							<option value="1">All</option>
						</select>
					</div>
				</div>
				<div class="block-options">
					<div class="input-group">
						<input v-model="search" type="text" name="search" class="form-control" placeholder="Search" />
						<!-- <span class="input-group-btn ms-1">
							<button type="button" class="btn btn-info"><i class="fa fa-search me-1"></i>Search</button>
						</span> -->
					</div>
				</div>
			</div>
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-hover table-vcenter dataTable">
						<thead>
							<tr>
								<th @click="sortByHeader('category',0)" class="sorting sorting_asc">CATEGORY</th>
								<th @click="sortByHeader('stock',1)" class="sorting">STOCK</th>
								<th @click="sortByHeader('tradeprice',2)" class="sorting">TRADE PRICE</th>
								<th @click="sortByHeader('buybelowprice',3)" class="sorting">BELOW PRICE</th>
								<th @click="sortByHeader('tradeprice',4)" class="sorting">TARGET PRICE</th>
								<th @click="sortByHeader('maxperc',5)" class="sorting">MAX %</th>
								<th @click="sortByHeader('dividend_yield_25e',6)" class="sorting">DIVIDEND YIELD %</th>
								<th @click="sortByHeader('actiontotake',7)" class="sorting">ACTION</th>
								<th @click="sortByHeader('lasttradedate',8)" class="sorting">TRADE LAST UPDATE</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(stock, c_index) in stocksData.data"
								:key="stock.counter"
							>
								<td>
									{{stock.category}}
								</td>
								<td>
									{{stock.stock}}
									<span v-if="stock.is_boss==1" class="ms-1 badge bg-success">BOSS</span>
								</td>
								<td>{{stock.tradeprice}}</td>
								<td>{{stock.buybelowprice}}</td>
								<td>{{stock.targetprice}}</td>
								<td>{{stock.maxperc}}</td>
								<td>{{stock.dividend_yield_25e	}}</td>
								<td>
									<span :class="{'text-success':stock.actiontotake=='Continue Buying','text-danger':stock.actiontotake=='Stop Buying','text-warning':stock.actiontotake=='Sell','text-secondary':stock.actiontotake=='Hold'}">
										{{stock.actiontotake}}
									</span>
								</td>
								<td>{{stock.lasttradedate}}</td>
								<td nowrap="" class="text-end">
									<button @click="viewStockDetailsComments(c_index)" type="button" class="btn btn-sm btn-alt-warning mb-1" title="View Stock Details Comments"><i class="fa fa-comment"></i></button>
									<br/>
									<button @click="viewStockDetails(c_index)" type="button" class="btn btn-sm btn-alt-success mb-1" title="View Stock Details"><i class="fa fa-search"></i></button>
									<br/>
									<button @click="viewSamTableModal(c_index,'update')" type="button" class="btn btn-sm btn-alt-info" title="Update Sam Table"><i class="fa fa-pencil-alt"></i></button>
								</td>
							</tr>
							<tr v-if="stocksData.data.length <= 0">
								<td colspan="10" class="mb-0 fw-semibold text-center p-5">NO STOCK FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="stocksData.data.length > 0" :collections="stocksData"/>
			</div>
		</div>

		<add-update-sam-table-modal ref="addUpdateSamTableModal" @update-action="updateAction" />
		<update-stock-details-modal ref="updateStockDetailsModal" size="modal-lg"/>
		<add-update-stock-details-comments-modal ref="addUpdateStockDetailsCommentsModal" @update-action="updateAction" />

	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import AddUpdateSamTableModal from '../../Components/Admin/AddUpdateSamTableModal'
import UpdateStockDetailsModal from '../../Components/Admin/UpdateStockDetailsModal'
import AddUpdateStockDetailsCommentsModal from '../../Components/Admin/AddUpdateStockDetailsCommentsModal'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		stocks		: Object,
		filter 		: String,
		search 		: String,
		api_response: Object
	},
	components:{AddUpdateSamTableModal,UpdateStockDetailsModal,AddUpdateStockDetailsCommentsModal},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const filter = ref(props.filter);
		const search = ref(props.search);

		const stocksData = reactive(props.stocks);
		const action = ref('add');
		const sortOrder = ref(1);
		const sortBy = ref('category');

		const toast = createToaster();

		const selectedStockContent = reactive({});

		const addUpdateSamTableModal 				= ref(null);
		const updateStockDetailsModal 				= ref(null);
		const addUpdateStockDetailsCommentsModal 	= ref(null);

		const updateAction = (_action)=>{
			action.value = _action;
		}

		const sortByHeader = (_sortBy,_column)=>{
			let cur_header = $("table.table thead > tr > th");
			
    		if(sortBy.value === _sortBy) {
	      		sortOrder.value = -sortOrder.value;
	      	} else {
	      		sortBy.value = _sortBy;
	      		sortOrder.value = 1;
	      	}
	      	
	      	for (var i = 0; i < cur_header.length; i++) {
                if(i!==_column)
                {
                    cur_header.eq(i).removeClass("sorting_asc").removeClass("sorting_desc");    
                }
                
            }

	      	if(cur_header.eq(_column).hasClass("sorting_asc"))
	      	{
	      		cur_header.eq(_column).removeClass('sorting_asc').addClass('sorting_desc');
	      	}else{
	      		cur_header.eq(_column).removeClass('sorting_desc').addClass('sorting_asc');
	      	}
	      	

	      stocksData.data = [...stocksData.data]
	        .sort((a,b) => {
	      	  	if (a[sortBy.value] >= b[sortBy.value]) {
	        		return sortOrder.value;
	          	}
	        	return -sortOrder.value
	      	})

      	}

		const viewSamTableModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedStockContent.counter 			= stocksData.data[_index].counter;
				selectedStockContent.category 			= stocksData.data[_index].category;
				selectedStockContent.stock 				= stocksData.data[_index].stock;
				selectedStockContent.stock_name 		= stocksData.data[_index].stock_name;
				selectedStockContent.tradeprice 		= stocksData.data[_index].tradeprice;
				selectedStockContent.buybelowprice 		= stocksData.data[_index].buybelowprice;
				selectedStockContent.targetprice 		= stocksData.data[_index].targetprice;
				selectedStockContent.maxperc 			= stocksData.data[_index].maxperc;
				selectedStockContent.dividend_yield_25e = stocksData.data[_index].dividend_yield_25e;
				selectedStockContent.actiontotake 		= stocksData.data[_index].actiontotake;
				selectedStockContent.is_boss 			= stocksData.data[_index].is_boss;
				selectedStockContent.boss_month 		= stocksData.data[_index].boss_month;
				selectedStockContent.boss_year 			= stocksData.data[_index].boss_year;
				selectedStockContent.is_active 			= stocksData.data[_index].is_active;
				selectedStockContent.stock_history 		= stocksData.data[_index].stock_history;
			}

			addUpdateSamTableModal.value.setSamTableContent(_action,selectedStockContent);

			addUpdateSamTableModal.value.toggleModal();

		}


		const viewStockDetails = (_index)=>{
			action.value = "update";
			selectedStockContent.counter 			= stocksData.data[_index].counter;
			selectedStockContent.stock 				= stocksData.data[_index].stock;
			selectedStockContent.tradeprice 		= stocksData.data[_index].tradeprice;
			selectedStockContent.buybelowprice 		= stocksData.data[_index].buybelowprice;
			selectedStockContent.targetprice 		= stocksData.data[_index].targetprice;
			selectedStockContent.maxperc 			= stocksData.data[_index].maxperc;
			selectedStockContent.actiontotake 		= stocksData.data[_index].actiontotake;
			selectedStockContent.is_boss 			= stocksData.data[_index].is_boss;
			selectedStockContent.stock_details 		= stocksData.data[_index].stock_details.length>0 ? stocksData.data[_index].stock_details[0]: null;

			updateStockDetailsModal.value.setStockDetailsContent(selectedStockContent);

			updateStockDetailsModal.value.toggleModal();

		}

		const viewStockDetailsComments = (_index)=>{
			
			selectedStockContent.counter 					= stocksData.data[_index].counter;
			selectedStockContent.stock 						= stocksData.data[_index].stock;
			selectedStockContent.stock_details_comments 	= stocksData.data[_index].stock_details_comments;

			addUpdateStockDetailsCommentsModal.value.setStockDetailsCommentContent(selectedStockContent);

			addUpdateStockDetailsCommentsModal.value.toggleModal();

		}


		watch(filter, (value,old_value) => {
			
			if(value!=old_value)
			{
				var param = {filter:value,search:search.value}

				if(value=="null")
				{
					param = "";
				}

				Inertia.get(
						'/admin/sam-table', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['stocks','filter','search'],
							onSuccess:(res)=>{
								Object.assign(stocksData,res.props.stocks);
							}
						}
					)
			}
		})

		watch(search, (value,old_value) => {
			
			if(value!=old_value)
			{
				var param = {filter:filter.value,search:value}

				if(value=="null")
				{
					param = "";
				}

				Inertia.get(
						'/admin/sam-table', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['stocks','filter','search'],
							onSuccess:(res)=>{
								Object.assign(stocksData,res.props.stocks);
							}
						}
					)
			}
		})


		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				let action_msg = (action.value=='add' ? 'added' : (action.value=='delete' ? 'deleted' : 'updated'));

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action.value, { type: "error"});
				}
			}
		})

		watch(()=>props.stocks, (value,old_value) => {
			if(value!=old_value)
			{
				Object.assign(stocksData,value);	
			}
			
		})

		return{
			filter,
			search,
			action,
			sortBy,
			sortOrder,
			sortByHeader,
			toast,
			viewSamTableModal,
			selectedStockContent,
			updateAction,
			addUpdateSamTableModal,
			updateStockDetailsModal,
			addUpdateStockDetailsCommentsModal,
			viewStockDetails,
			viewStockDetailsComments,
			stocksData
		}
	},
}
</script>
